/**
 * 获取文件的预览图
 * @param url
 */
export const getPreview = (url = '') => {
  if (url && url.indexOf("?") > 0) {
    url = url.substring(0, url.indexOf("?"));
  }
  // 返回对应文件类型的后缀
  const map = {
    ['.zip']: 'https://0.z.wiki/autoupload/2022-08-16/4ce28595bb5f4b898f595bcd2f628f8d.zip.svg',
    ['.svg']: 'https://6.z.wiki/autoupload/2022-09-18/4a9ab33c22d54f9f838801f145cb8516.SVG图标.svg',
    ['.pdf']: 'https://0.z.wiki/autoupload/2022-09-09/995ec22a130649e1b8aed3d83a648781.pdf.svg',
    ['.mp4']: 'https://4.z.wiki/autoupload/2022-09-16/343f6678edf54cf4a4527e3600f17cb2.MP4.svg',
    ['.html']: 'https://3.z.wiki/autoupload/2022-09-18/dfa2279d57f5479a83103dd9445958f5.html.svg',
    ['.htm']: 'https://3.z.wiki/autoupload/2022-09-18/dfa2279d57f5479a83103dd9445958f5.html.svg',
    ['.js']: 'https://z.wiki/autoupload/20240406/Qe7N.javascript.svg',
    ['.css']: 'https://cdn.z.wiki/autoupload/2022-09-18/f44b7e3b35de4dc2a33640619b64ca5c.CSS.svg',
    ['.java']: 'https://cdn.z.wiki/autoupload/2022-09-19/447070ea92a547e78d40a096d32a9c45.java.svg',
    ['.jsx']: 'https://cdn.z.wiki/autoupload/2022-09-19/95312e34636942eba6f57174c6c0c62f.jsx.svg',
    ['.vue']: 'https://z.wiki/autoupload/20240406/ZLQW.vue-config.svg',
    ['.sh']: 'https://z.wiki/autoupload/20240406/DOtp.SHELL.svg',
    ['.jar']: 'https://5.z.wiki/autoupload/2022-09-19/fd812b74b27a4f10a63b7459ebd3cef6.JAR.svg',
    ['.class']: 'https://8.z.wiki/autoupload/2022-09-19/a388ddc5203643daaa41c2b1ea1b883a.class.svg',
    ['.php']: 'https://8.z.wiki/autoupload/2022-09-18/80dbd4edcc4b4d2a96b5f3bda9f8ff25.PHP.svg',
    ['.ico']: 'https://4.z.wiki/autoupload/2022-09-18/14cad0db1f174478be7d038c740f95ec.图片.svg',
    ['.mp3']: 'https://5.z.wiki/autoupload/2022-09-18/6a714ce4fcb44a1b93a844388e510533.MP3.svg',
    ['.m4a']: 'https://img.51shazhu.com/autoupload/fdd/default/m4a.svg',
    ['.doc']: 'https://3.z.wiki/autoupload/2022-09-18/64880d19208a4eef99ce63c2f8494f68.doc.svg',
    ['.docx']: 'https://3.z.wiki/autoupload/2022-09-18/64880d19208a4eef99ce63c2f8494f68.doc.svg',
    ['.txt']: 'https://7.z.wiki/autoupload/20221224/5eVn.txt-ext.svg',
    ['.json']: 'https://7.z.wiki/autoupload/2022-09-18/194c5e66be6b44a5b88d95a7eea0c05e.JSON.svg',
    ['.md']: 'https://5.z.wiki/autoupload/2022-09-18/e0aa344b2d924b228d6a01026ed4b4e0.markdown.svg',
    ['.ppt']: 'https://2.z.wiki/autoupload/2022-09-18/728eb566f0644d108ab1d98f54561df5.ppt.svg',
    ['.pptx']: 'https://2.z.wiki/autoupload/2022-09-18/728eb566f0644d108ab1d98f54561df5.ppt.svg',
    ['.psb']: 'https://2.z.wiki/autoupload/2022-09-18/8a023049b2e749ff911099b338d77383.PS.svg',
    ['.xml']: 'https://2.z.wiki/autoupload/2022-09-18/b4247c301b0948708582c3f030cf664b.XML.svg',
    ['.csv']: 'https://2.z.wiki/autoupload/2022-09-18/306ac35844fa4117a1d317c91663b66c.CSV.svg',
    ['.key']: 'https://6.z.wiki/autoupload/2022-09-18/1326995267e345f192b9ecfdec36196a.keynote.svg',
    ['.torrent']: 'https://4.z.wiki/autoupload/2022-09-18/0942076a759345a4a28e5105439da15e.file_bt.svg',
    ['.xls']: 'https://6.z.wiki/autoupload/2022-09-18/8ed51cfaf5f04d88b7ef0f0eb13e0035.excel.svg',
    ['.xltx']: 'https://6.z.wiki/autoupload/2022-09-18/8ed51cfaf5f04d88b7ef0f0eb13e0035.excel.svg',
    ['.xlsm']: 'https://6.z.wiki/autoupload/2022-09-18/8ed51cfaf5f04d88b7ef0f0eb13e0035.excel.svg',
    ['.xlsb']: 'https://6.z.wiki/autoupload/2022-09-18/8ed51cfaf5f04d88b7ef0f0eb13e0035.excel.svg',
    ['.alfredworkflow']: 'https://1.z.wiki/autoupload/20221224/FwUM.workflow.svg',
    ['.tiff']: 'https://3.z.wiki/autoupload/20221224/x2Fz.Tiff.svg',
    ['.exe']: 'https://5.z.wiki/autoupload/20221224/PvKj.exe.svg',
    ['.7z']: 'https://0.z.wiki/autoupload/20221224/NpA2.7z.svg',
    ['.rar']: 'https://3.z.wiki/autoupload/20221224/uRGw.rar.svg',
    ['.gz']: 'https://6.z.wiki/autoupload/20221224/GUg7.gzip.svg',
    ['.ts']: 'https://7.z.wiki/autoupload/20221224/X169.typescript-def.svg',
    ['.config']: 'https://z.wiki/autoupload/20240406/tzaa.config---.svg',
    ['.dmg']: 'https://5.z.wiki/autoupload/20221224/0IXD.dmg.svg',
    ['.py']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/py.svg',
    ['.rb']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/rb.svg',
    ['.go']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/go.svg',
    ['.rs']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/rs.svg',
    ['.c']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/c.svg',
    ['.cpp']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/cpp.svg',
    ['.h']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/h.svg',
    ['.swift']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/swift.svg',
    ['.kt']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/kt.svg',
    ['.tsx']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/tsx.svg',
    ['.sql']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/sql.svg',
    ['.scss']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/scss.svg',
    ['.sass']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/sass.svg',
    ['.less']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/less.svg',
    ['.yaml']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/yaml.svg',
    ['.yml']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/yml.svg',
    ['.ini']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/ini.svg',
    ['.toml']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/toml.svg',
    ['.env']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/env.svg',
    ['.properties']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/properties.svg',
    ['.tar']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/tar.svg',
    ['.tgz']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/tgz.svg',
    ['.bz2']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/bz2.svg',
    ['.avi']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/avi.svg',
    ['.mov']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/mov.svg',
    ['.mkv']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/mkv.svg',
    ['.flv']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/flv.svg',
    ['.wmv']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/wmv.svg',
    ['.webm']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/webm.svg',
    ['.wav']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/wav.svg',
    ['.flac']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/flac.svg',
    ['.aac']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/aac.svg',
    ['.ogg']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/ogg.svg',
    ['.iso']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/iso.svg',
    ['.log']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/log.svg',
    ['.db']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/db.svg',
    ['.sqlite']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/sqlite.svg',
    ['.psd']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/psd.svg',
    ['.ai']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/ai.svg',
    ['.sketch']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/sketch.svg',
    ['.apk']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/apk.svg',
    ['.ipa']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/ipa.svg',
    ['.deb']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/deb.svg',
    ['.rpm']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/rpm.svg',
    ['.ttf']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/ttf.svg',
    ['.otf']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/otf.svg',
    ['.woff']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/woff.svg',
    ['.woff2']: 'https://1.z.wiki/autoupload/fdd/default/file-icons/file-icons/woff2.svg'
  };
  let icon = 'https://5.z.wiki/autoupload/2022-09-18/a426d828fa6242cdb9698fbe32a430a4.unknownfile.svg';
  Object.keys(map).forEach(suffix => {
    if (url.toLowerCase().endsWith(suffix)) {
      icon = (map as any)[suffix];
    }
  })
  return icon;
}
